import * as yup from 'yup';

export const documentSchema = yup.object().shape({
  gyno: yup.string().required("Please enter doctor's name"),
  hospital: yup.string().required("Please enter hospital name"),
  phone: yup.string().matches(/^[6-9]\d{9}$/, 'Please enter valid number.').required("Please enter phone number"),
  document: yup.object().shape({
    documentType: yup.number().required("Select type of document"),
    appointment: yup.date().typeError("Please enter date").required(),
    description: yup.string().required("description is required"),
    title: yup.string().required("Title is required")
  })
})


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/documentSchema.js